import axios from 'axios';
import { getApiUrl } from './apiBase';
import { FurnitureData } from './furniture';

const url = `${getApiUrl()}/auth/saved`;
const config = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

export const savedService = {
  async list(): Promise<FurnitureData[]> {
    const { data } = await axios.get(url, config());
    return data;
  },
  async save(id: string): Promise<void> {
    await axios.put(`${url}/${id}`, {}, config());
  },
  async remove(id: string): Promise<void> {
    await axios.delete(`${url}/${id}`, config());
  },
  async clear(): Promise<void> {
    await axios.delete(url, config());
  },
};
